export default __webpack_public_path__ + "static/media/todo.f3e55942.png";